import { WppTypography } from '@wppopen/components-library-react'
import { snakeCaseToSentenceCase } from 'utils'
import { v4 as uuidv4 } from 'uuid'
import type { SanitisedProductData } from '../AiOutput.d'
import type { JobBrandConfigContentConfig, JobContentTypes, v5 } from '@contracts'
import styles from './AiOutputTextBlock.module.scss'
import clsx from 'clsx'
import React from 'react'

interface AiOutputTextBlockProps {
  outputData: JobContentTypes | JobBrandConfigContentConfig | SanitisedProductData | v5.RetailersDetailData
}

const AiOutputTextBlock = ({ outputData }: AiOutputTextBlockProps) => {
  const renderText = (text: any) => {
    if (!text) {
      return null
    } else if (Array.isArray(text)) {
      return renderTextArray(text)
    } else if (typeof text === 'object') {
      return renderTextObj(text)
    } else {
      return renderTextString(text)
    }
  }

  const renderTextString = (text: string) => {
    return <span className={styles.infoText}>{` "${text}"`}</span>
  }

  const renderTextObj = (textObj: object) => {
    return (
      <ul className={styles.outputtedObject} key={uuidv4()} data-testid="output-data-list">
        {Object.entries(textObj)?.map(([title, value]) => (
          <li key={uuidv4()}>
            <WppTypography type="s-body" tag="p" data-testid="output-list-item">
              {snakeCaseToSentenceCase(title)}:
              {Array.isArray(value) ? (
                renderTextArray(value)
              ) : (
                <span className={styles.infoText} data-testid="output-list-value">{` "${value}"`}</span>
              )}
            </WppTypography>
          </li>
        ))}
      </ul>
    )
  }

  const renderTextArray = (textList: (string | object)[]) => {
    return (
      <span className={styles.infoText} data-testid="output-array-text">
        {textList?.map(item =>
          typeof item === 'object' ? (
            renderTextObj(item as object)
          ) : (
            <span key={uuidv4()} data-testid="output-single-array-item">
              {' '}
              "{item}"
            </span>
          ),
        )}
      </span>
    )
  }

  const processObject = (obj: object, isNested: boolean = false) => {
    return Object.entries(obj)?.map(([subtitle, text]) => (
      <div key={uuidv4()} className={clsx(isNested && styles.outputtedObject)} data-testid="output-data-inner">
        <WppTypography type="s-body" tag="p" data-testid="output-data-item">
          {snakeCaseToSentenceCase(subtitle)}:{renderText(text)}
        </WppTypography>
      </div>
    ))
  }

  return (
    <>
      {Array.isArray(outputData) ? (
        outputData?.map(item =>
          typeof item === 'string' ? (
            <WppTypography
              className={styles.outputDataArray}
              type="s-body"
              tag="p"
              key={uuidv4()}
              data-testid="output-data-item"
            >
              {`"${item}"`}
            </WppTypography>
          ) : (
            <React.Fragment key={item.id || uuidv4()}>
              <WppTypography
                type="m-body"
                className={styles.outputtedObject}
                tag="p"
                data-testid="array-object-output-title"
              >
                {snakeCaseToSentenceCase(item?.title || '')}
              </WppTypography>
              <br />
              <ul className={styles.outputtedObject} data-testid="array-object-list-item">
                {processObject(item, true)}
              </ul>
            </React.Fragment>
          ),
        )
      ) : (
        <div data-testid="none-array-data-container">{processObject(outputData)}</div>
      )}
    </>
  )
}

export default AiOutputTextBlock
